import { render, staticRenderFns } from "./previewHandout.vue?vue&type=template&id=7f5a806a&"
import script from "./previewHandout.vue?vue&type=script&lang=js&"
export * from "./previewHandout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports